import PropTypes from "prop-types";
import React, { useEffect, Suspense, lazy } from "react";
import ScrollToTop from "./helpers/scroll-top";
import { HashRouter as Router, Switch, Route, BrowserRouter, Redirect } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";
import { multilanguage, loadLanguages } from "redux-multilanguage";
import { connect } from "react-redux";
import { BreadcrumbsProvider } from "react-breadcrumbs-dynamic";
import { ProtectedRoute, AuthRoute } from "./util/auth/routeUtil";
import { createBrowserHistory } from "history";
import Version from './pages/version/version';

import PrimeReact from 'primereact/api';

import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import './App.scss';
import './assets/layout/layout.scss';



// home pages


const LazyWelcome = lazy(() => import("./pages/home/Welcome"));
const LoginRegister = lazy(() => import("./pages/other/LoginRegister"));
const ForgotPassword = lazy(() => import("./pages/other/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/other/ResetPassword"));
const ChangePassword = lazy(() => import("./pages/settings/ChangePassword"));
const Orders = lazy(() => import("./pages/orders/Orders"));
const OrderShowPage = lazy(() => import("./pages/order-detail/OrderShowPage"));
const Artwork = lazy(() => import("./pages/artwork/Artwork"));
const Quotes = lazy(() => import("./pages/quotes/Quotes"));
const ArtworkShow = lazy(() => import("./pages/artwork-detail/ArtworkShowPage"));
const QuoteShowPage = lazy(() => import("./pages/quote-detail/QuoteShowPage"));
const QuoteItemShowPage = lazy(() => import("./pages/quote-item-detail/QuoteItemShowPage"));
const QuoteItemRowShowPage = lazy(() => import("./pages/quote-item-row-detail/QuoteItemRowShowPage"));
const CatalogueShow = lazy(() => import("./pages/catalogue-detail/CatalogueShowPage"));
const Catalogue = lazy(() => import("./pages/catalogue/Catalogue"));
const Reports = lazy(() => import("./pages/reports/Reports"));
const Marketing = lazy(() => import("./pages/marketing/MCatalogue"));
const MarketingShow = lazy(() => import("./pages/mcatalogue-detail/MCatalogueShowPage"));
const Dashboard = lazy(() => import("./pages/dashboard/Dashboard"));
const ViewCartContainer = lazy(() => import("./pages/view-cart/ViewCartContainer"));
const QuoteCatalogue = lazy(() => import("./pages/quote-catalogue/QCatalogue"));
const QuoteCatalogueShow = lazy(() => import("./pages/quote-catalogue/QuoteItemShowPage"));

const NotFound = lazy(() => import("./pages/other/NotFound"));

const App = (props) => {
  useEffect(() => {
    props.dispatch(
      loadLanguages({
        languages: {
          en: require("./translations/english.json"),
          fn: require("./translations/french.json"),
          de: require("./translations/germany.json")
        }
      })
    );
  });
  PrimeReact.ripple = true;
  PrimeReact.zIndex = {
    modal: 1100,
    overlay: 3000,
    menu: 1000,
    tooltip: 1100,
    toast: 1200
  };
  const hist = createBrowserHistory();
  const portalPermissions = props.portalPermissions ? props.portalPermissions : [];
  return (
    <ToastProvider placement="top-right">
      <BreadcrumbsProvider>
        <BrowserRouter basename="/cp" history={hist}>
          <ScrollToTop>
            <Suspense
              fallback={
                <div className="flone-preloader-wrapper">
                  <div className="flone-preloader">
                    <span></span>
                    <span></span>
                  </div>
                </div>
              }
            >
              <Switch>
                <ProtectedRoute exact path={"/"} component={LazyWelcome} />
                {portalPermissions && portalPermissions.DashBoard && portalPermissions.DashBoard[0].isShow && <ProtectedRoute exact path={"/dashboard"} component={Dashboard} />}
                {/* Homepages */}
                {portalPermissions && portalPermissions.Order && portalPermissions.Order[0].isShow && <ProtectedRoute component={Orders} path={"/orders"} />}
                {portalPermissions && portalPermissions.Order && portalPermissions.Order[0].isShow && <ProtectedRoute component={OrderShowPage} exact path={"/order-detail/:id"} />}
                {portalPermissions && portalPermissions.Quote && portalPermissions.Quote[0].isShow && <ProtectedRoute component={Quotes} path={"/quotes"} />}
                {portalPermissions && portalPermissions.Quote && portalPermissions.Quote[0].isShow && <ProtectedRoute
                  exact
                  component={QuoteShowPage}
                  path={"/quote-detail/:id"}
                />}
                <Route
                  exact
                  component={QuoteShowPage}
                  path={"/quote-preview/:id"}
                />
                <Route
                  exact
                  component={QuoteCatalogue}
                  path={"/quote-catalogue/:quoteId"}
                />
                <ProtectedRoute
                  exact
                  component={QuoteCatalogueShow}
                  path={"/quote-catalogue-detail/:qid/:id"}
                />
                <Route
                  exact
                  component={Orders}
                  path={"/order"}
                />
                <Route exact path="/version" component={Version} />

                <Route
                  exact
                  component={QuoteItemShowPage}
                  path={"/quote-item-preview/:qid/:id"}
                />
                {portalPermissions && portalPermissions.Quote && portalPermissions.Quote[0].isShow && <ProtectedRoute
                  exact
                  component={QuoteItemShowPage}
                  path={"/quote-item-detail/:qid/:id"}
                />}
                {portalPermissions && portalPermissions.Quote && portalPermissions.Quote[0].isShow && <ProtectedRoute
                  exact
                  component={QuoteItemRowShowPage}
                  path={"/quote-item-row-detail/:qid/:id/:row_id"}
                />}
                {portalPermissions && portalPermissions.Artwork && portalPermissions.Artwork[0].isShow && <ProtectedRoute component={Artwork} path={"/artwork"} />}
                {portalPermissions && portalPermissions.Artwork && portalPermissions.Artwork[0].isShow && <ProtectedRoute
                  exact
                  component={ArtworkShow}
                  path={"/artwork-detail/:id"}
                />}
                {portalPermissions && portalPermissions.Catalogue && portalPermissions.Catalogue[0].isShow && <ProtectedRoute
                  exact
                  component={CatalogueShow}
                  path={"/catalogue-detail/:id"}
                />}
                {portalPermissions && portalPermissions.Catalogue && portalPermissions.Catalogue[0].isShow && <ProtectedRoute component={Catalogue} path={"/catalogue"} loc={window.location} />}
                {portalPermissions && portalPermissions.Catalogue && portalPermissions.Catalogue[0].isShow && <ProtectedRoute component={ViewCartContainer} path={"/cart"} />}
                {portalPermissions && portalPermissions.Report && portalPermissions.Report[0].isShow && <ProtectedRoute component={Reports} path={"/reports"} />}
                {portalPermissions && portalPermissions.Marketing && portalPermissions.Marketing[0].isShow && <ProtectedRoute component={Marketing} path={"/marketing"} />}
                {portalPermissions && portalPermissions.Marketing && portalPermissions.Marketing[0].isShow && <ProtectedRoute component={MarketingShow} path={"/marketing-detail/:id"} />}

                <ProtectedRoute exact path={"/changepassword"} component={ChangePassword} />
                {/* Other pages */}
                <AuthRoute exact path={"/reset-password"} component={ResetPassword} />
                <AuthRoute exact path={"/forgot-password"} component={ForgotPassword} />
                <AuthRoute exact path={"/login"} component={LoginRegister} />
                <AuthRoute exact path={"/:name"} component={LoginRegister} />
                <AuthRoute exact path={"/login/:name"} component={LoginRegister} />
                <Redirect from="/*" to="/" />
                <Route
                  path={process.env.PUBLIC_URL + "/not-found"}
                  component={NotFound}
                />

                <Route exact component={NotFound} />
              </Switch>
            </Suspense>
          </ScrollToTop>
        </BrowserRouter>
      </BreadcrumbsProvider>
    </ToastProvider>
  );
};
const mapStateToProps = state => {
  return {
    portalPermissions: state.session.user && state.session.user.portalPermissions
  };
};
App.propTypes = {
  dispatch: PropTypes.func
};

export default connect(mapStateToProps, null)(multilanguage(App));
